import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Clock } from "lucide-react";

interface TimePickerProps {
  value: string | null;
  onChange: (time: string | null) => void;
}

export const TimePicker = ({ value, onChange }: TimePickerProps) => {
  const hours = value ? value.split(":")[0] : "";
  const minutes = value ? value.split(":")[1] : "";

  const handleChange = (h: string, m: string) => {
    if (h && m) {
      onChange(`${h}:${m}`);
    } else {
      onChange(null);
    }
  };

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className="space-y-3 rounded-lg border border-border p-4 bg-muted/30">
      <Label className="font-semibold flex items-center gap-2">
        <Clock className="h-4 w-4" />
        Horário permitido
      </Label>
      <p className="text-xs text-muted-foreground">
        Você só poderá marcar este hábito 5 minutos antes ou depois do horário escolhido.
      </p>

      <div className="flex items-center gap-2">
        <Select value={hours} onValueChange={(h) => handleChange(h, minutes || "00")}>
          <SelectTrigger className="w-24">
            <SelectValue placeholder="Hora" />
          </SelectTrigger>
          <SelectContent>
            {Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0")).map((h) => (
              <SelectItem key={h} value={h}>{h}</SelectItem>
            ))}
          </SelectContent>
        </Select>

        <span className="text-lg font-bold">:</span>

        <Select value={minutes} onValueChange={(m) => handleChange(hours || "00", m)}>
          <SelectTrigger className="w-24">
            <SelectValue placeholder="Min" />
          </SelectTrigger>
          <SelectContent>
            {["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"].map((m) => (
              <SelectItem key={m} value={m}>{m}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <p className="text-xs text-muted-foreground">
        Fuso horário: {timezone}
      </p>
    </div>
  );
};
